import { Component, OnInit } from '@angular/core';
import { DashboardService } from '@teem/services/dashboard.service';

@Component({
	selector: 'top-products',
	templateUrl: './top-products-table.component.html',
	styleUrls: ['./top-products-table.component.scss']
})
export class TopProductsTableComponent implements OnInit {
	// products = [
	//   { name: 'Shoes', price: '5,903.30 SAR', sold: '400 pcs', earnings: 5903.3 },
	//   { name: 'Shoes', price: '5,903.30 SAR', sold: '400 pcs', earnings: 5903.3 },
	//   { name: 'Shoes', price: '5,903.30 SAR', sold: '400 pcs', earnings: 5903.3 },
	//   { name: 'Shoes', price: '5,903.30 SAR', sold: '400 pcs', earnings: 5903.3 },
	//   { name: 'Shoes', price: '5,903.30 SAR', sold: '400 pcs', earnings: 5903.3 }
	// ];

	products: any = [];
	storeType: string = '';

	constructor(
		private dashboardService: DashboardService,
	) {

	}
	ngOnInit(): void {
		this.getTopProducts();
	}

	getTopProducts() {
		this.products = [];
		this.dashboardService.getTopProducts().subscribe((response: any = []) => {
			this.products = response.products;
			this.storeType = response.business_type
		});
	}
}
